import {ObjectDetectionTrainer} from './scripts/ObjectDetection.js'
import DataLabeler from './src/DataLabeler/DataLabeler.vue'
import DataCollector from './src/DataCollector/DataCollector.vue'
import ObjectDetection from './src/ObjectDetection.vue'

import ObjectDetectionTest from './src/Test.vue'
import ObjectDetectionTest2 from './src/ObjectDetection2.vue'


DataLabeler.install = function(Vue) {
    Vue.component(DataLabeler.name, DataLabeler)
}

DataCollector.install = function(Vue) {
    Vue.component(DataCollector.name, DataCollector)
}

ObjectDetection.install = function(Vue) {
    Vue.component(ObjectDetection.name, ObjectDetection)
}

ObjectDetectionTest.install = function(Vue) {
    Vue.component(ObjectDetectionTest.name, ObjectDetectionTest)
}

ObjectDetectionTest2.install = function(Vue) {
    Vue.component(ObjectDetectionTest2.name, ObjectDetectionTest2)
}

export {
    ObjectDetectionTrainer,
    ObjectDetectionTest,
    ObjectDetectionTest2,
    DataLabeler,
    DataCollector,
    ObjectDetection
}